import {evite} from 'evite';
import * as _React from 'node-modules-react';

Object.assign(exports, _React);
evite.assert(_React.Component, 'Possibly using a minified version of react');
evite.set(evite, 'exports.React', exports);

window.React = exports;
